




















































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { UserModule } from "@/store/modules/User";
import SearchCustomerPersonal from "./search-modal-customer/search-modal-customer-personal.vue";
import SearchCustomerCollection from "./search-modal-customer/search-modal-customer-collection.vue";
import SearchModalHeader from "@/views/search/search-modal-header.vue";
import Person from "@/components/icons/person.vue";
import CustomerModel from "@/models/CustomerModel";
import SystemModel from "@/models/SystemModel";
import trackEvent from "@/plugins/track-event";

const customerQuery = (customerId: number) => {
    return `{
            customer(id: ${customerId}) {
                info {
                    id
                    referenceNo
                    idNo
                    name
                    adress1
                    adress2
                    city
                    postNo
                    customerType
                    externReference
                    countryCode
                    regDate
                    tag
                }
                system {
                    businessType country { countryName }
                }
                cases(orderBy: { path: "case.info.regDate", descending: true }) {
                    case {
                        info {
                            id
                            caseNo
                            caseType
                            remainingTotal
                            regDate
                            closureDate
                            state
                            statusCode
                            systemId
                        }
                        creditor {
                            creditorName
                            system { businessType }
                        }
                    }
                }
            }
        }`;
};

@Component({
    components: { SearchModalHeader, SearchCustomerCollection, SearchCustomerPersonal, Person },
    metaInfo() {
        const name = (this as SearchCustomerComponent).customer.info.name;

        return {
            title: name ? this.$t("search.customerName", { name }) as string : this.$t("search.customer") as string
        };
    }
})
export default class SearchCustomerComponent extends Vue {
    isLoading = false;
    isLoadingDetails = false;
    isEditing = false;

    customer: any = {
        info: {},
        cases: [],
        system: {},
        details: {}
    };

    disableModal = false;

    created() {
        this.getCustomer();
        this.getCustomerDetails();
    }

    get isMobile() {
        return UserModule.isMobileGlobal;
    }

    get isCompany() {
        return CustomerModel.isCompany(this.customer.info.customerType);
    }

    get isPerson() {
        return CustomerModel.isPerson(this.customer.info.customerType);
    }

    get isCollection() {
        return SystemModel.isCollection(this.customer.system);
    }

    get isPreCollection() {
        return SystemModel.isPreCollection(this.customer.system);
    }

    get editRights() {
        return UserModule.accessRights?.some(accessRight => accessRight.rightName === "EditDebtor");
    }

    async getCustomer() {
        this.isLoading = true;
        const response = await this.$api.graphql({ query: customerQuery(Number(this.$route.params.id)) });
        const { customer } = response.data;
        this.isLoading = false;

        this.$set(this.customer, "info", customer.info);
        this.customer.cases = customer.cases.map((caseData: any) => caseData.case);
        this.customer.system = customer.system;
    }

    async getCustomerDetails() {
        this.isLoadingDetails = true;
        try {
            const { data } = await this.$api.graphql({
                query: `query($customerid: Int) {
                    customerDetails(customerid: $customerid) {
                        email
                        telephone
                        telephone2
                        lastPaymentDate
                        numFullyPaidCases
                        numInstallmenPlans
                        sumPaid
                        sumRemaining
                        cityCode
                        cityCode2
                        addr1
                        addr2
                        city
                    }
                }`,
                variables: {
                    customerid: this.$route.params.id
                }
            });

            const [details] = data.customerDetails;

            this.customer.details = details;
            if(this.customer.details.cityCode2) {
                this.customer.details.cityCode2 = this.customer.details.cityCode2.trim();
            }
            this.isLoadingDetails = false;
        } catch(error) {
            this.disableModal = true;
            this.isLoadingDetails = false;
            this.$apm.captureError(error as any);
        }
    }

    async saveCustomer() {
        this.isEditing = false;
        try {
            const { data } = await this.$api.graphql({
                query: `mutation($customerId: Int!, $addr1: String!, $addr2: String!, $zip: String!, $zip2: String, $city: String!, $phone1: String!, $phone2: String!, $email: String!) {
                    novaUpdateCustomerInfo(customerId: $customerId, addr1: $addr1, addr2: $addr2, zip: $zip, zip2: $zip2, city: $city, phone1: $phone1, phone2: $phone2, email: $email) {
                        id
                    }
                }`,
                variables: {
                    customerId: this.$route.params.id,
                    addr1: this.customer.details.addr1,
                    addr2: this.customer.details.addr2,
                    zip: this.customer.details.cityCode,
                    zip2: this.customer.details.cityCode2,
                    city: this.customer.details.city,
                    phone1: this.customer.details.telephone,
                    phone2: this.customer.details.telephone2,
                    email: this.customer.details.email
                }
            });
            const metaData = JSON.stringify({ id: this.customer.info.id, referenceNo: this.customer.info.referenceNo });
            trackEvent("consumer", "editconsumer", metaData);
            this.$notifications.success({ message: this.$t("search.saveCustomerSuccess") as string });
        } catch (error) {
            this.$notifications.error({ message: this.$t("search.saveCustomerFail") as string });
            this.$apm.captureError(error as any);
        }
    }

    get mypages() {
        return process.env.VUE_APP_MY_PAGES && UserModule.roles && (UserModule.roles.includes("MyPages.Impersonate") || UserModule.roles.includes("MyPages.Impersonate.ReadOnly"));
    }

    openMyPages(customer: any) {
        window.open(process.env.VUE_APP_MY_PAGES + customer.system.country.countryName.toLowerCase() + "/login?d=" + customer.info.referenceNo, "_blank");
    }
}
